import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import useIntersectionObserver from '@dashboard/hooks/useIntersectionObserver';

const BottomScrollListener = ({
  as = 'div',
  onBottom,
  children,
  isLoadingMore,
  ...props
}) => {
  const [scrollListenerRef, scrollListener] = useIntersectionObserver({
    threshold: 0,
    rootMargin: '50px',
  });

  useEffect(() => {
    if (scrollListener.isIntersecting && !isLoadingMore) {
      onBottom();
    }
  }, [scrollListener.isIntersecting, children?.length]);

  const Component = as;

  return (
    <Component {...props}>
      {children}

      <div ref={scrollListenerRef} />
    </Component>
  );
};

BottomScrollListener.propTypes = {
  onBottom: PropTypes.func.isRequired,
};

export default BottomScrollListener;
